import { IDirective, ITimeoutService, IScope, IAugmentedJQuery, IAttributes, IPromise, IModule } from "angular";

interface ICountToScope extends IScope {
  timoutId: IPromise<unknown>;
  value: number;
}

export class CountToDirective implements IDirective {
  scope = true;

  constructor(private $timeout: ITimeoutService) {}

  link(scope: ICountToScope, element: IAugmentedJQuery, attrs: IAttributes): void {
    const e = element[0];
    const refreshInterval = 30;
    let num: number;
    let steps: number;
    let step: number;
    let countto: number;
    let increment: number;

    const calculate = () => {
      step = 0;
      scope.timoutId = null;
      countto = parseInt(attrs.countto) || 0;
      scope.value = parseInt(attrs.value, 10) || 0;

      const duration = parseFloat(attrs.duration) * 1000 || 0;
      steps = Math.ceil(duration / refreshInterval);
      increment = (countto - scope.value) / steps;
      num = scope.value;
    };

    const tick = () => {
      scope.timoutId = this.$timeout(() => {
        num += increment;
        step++;
        if (step >= steps) {
          this.$timeout.cancel(scope.timoutId);
          num = countto;
          e.textContent = countto.toString();
        } else {
          e.textContent = Math.round(num).toString();
          tick();
        }
      }, refreshInterval);
    };

    const start = () => {
      if (scope.timoutId) {
        this.$timeout.cancel(scope.timoutId);
      }
      calculate();
      tick();
    };

    attrs.$observe("countto", function (val) {
      if (val) {
        start();
      }
    });

    attrs.$observe("value", function () {
      start();
    });
  }

  static register(mod: IModule): void {
    mod.directive("countto", ["$timeout", ($timeout: ITimeoutService) => new CountToDirective($timeout)]);
  }
}
